<template>
  <div class="content-table" style="height:100%">
    <div class="content-row error_margin">
      <img src="/index/static/image/chacha.png" align="absmiddle" />
      <span class="error">信用余额不足,可申请临时额度</span>
    </div>
    <div class="content-row apply_title">
      <img src="/index/static/image/hongxian.png" align="absmiddle" /> 申请临时额度
    </div>
    <div class="content-row" style="height:20%">
      <textarea class="apply_content" placeholder="申请说明" v-model="explain"></textarea>
    </div>
    <div class="content-row" style=" text-align: right;">
      <button class="apply_sub" @click="sub_order">提交</button>
    </div>
  </div>
</template>

<script>
// import { debuglog } from "util";
var total_row = [];
export default {
  name: "",
  components: {},

  data() {
    return {
        explain:""//说明
    };
  },
  mounted() {
    this.view();
  },
  watch: {},
  methods: {
    view() {

    },
    sub_order() {
      var express_type = this.$route.query.express_type; 
      var promo_code = this.$route.query.promo_code; 
      var remark = this.$route.query.remark; 
      var express_pay = this.$route.query.express_pay; 
      var operator = this.$route.query.operator; 
      var addr_id = this.$route.query.addr_id; 
        // return;
      this.$axios({
        method: "post",
        url: "/index/order/place_order",
        params: {
          express_type: express_type,
          promo_code: promo_code,
          remark: remark,
          express_pay: express_pay,
          operator: operator,
          addr_id: addr_id,
          pay_type: "temp",
          order_type: "SO",
          credit_remark:this.explain
        }
      })
        .then(res => {
            this.$message1(res.data.msg);
            this.$router.push({
            path: "/personal/index",
             query: {
              page_name: "我的订单",
              menu_id: 1,
            }
          });
          
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
.content-row {
  text-align: center;
}
.error {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(219, 33, 45, 1);
}
.error_margin {
  margin-top: 5%;
}
.apply_title {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-top: 5%;
}
.apply_content {
  background: rgba(238, 238, 238, 1);
  border-radius: 6px;
  resize: none;
  width: 99%;
  height: 100%;
  font-size: 18px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.apply_sub {
  width: 98px;
  height: 30px;
  background: rgba(219, 33, 45, 1);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border: none;
  margin: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/pro_quota.vue